export enum DateFormat {
  weekdayName = "EEEE", // Monday
  shortWeekdayNameWithOrdinal = "ccc do", // Thu 12th
  shortWeekdayNameWithMonthAndDate = "EEE, MMM d", // Mon, Jan 13
  shortMonthNameWithDateAndTime = "MMM d, h:mmaaa", // Jan 13, 2:45pm
  monthNameWithOrdinal = "MMMM do", // January 13th
  monthName = "MMMM", // January
  monthNameWithYear = "MMMM yyyy", // January 2025
}
